export class CustomerType {
    ID: number;
    Name: string;
}

export default CustomerType;